// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import QS from 'qs'
import Vuex from 'vuex'
import store from './store/store'
Vue.prototype.$axios = axios;
Vue.prototype.qs = QS;
Vue.config.productionTip = false
Vue.use(Vuex);

// import VConsole from 'vconsole';
// new VConsole();

import axios from "./request/axios";
Vue.prototype.axios = axios;

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
import {Toast} from 'vant';
Vue.use(Toast);
import { Locale } from 'vant';
// 引入英文语言包
import en from 'vant/es/locale/lang/en-US';

Locale.use('en-US', en);

import VConsole from 'vconsole'
// new VConsole()
//复制
import VueClipboards from 'vue-clipboard2'
Vue.use(VueClipboards);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js